"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _getIcon = _interopRequireDefault(require("../../services/getIcon"));

var _stylingUtils = require("../../services/stylingUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var RheIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RheIcon, _React$Component);

  function RheIcon() {
    _classCallCheck(this, RheIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(RheIcon).apply(this, arguments));
  }

  _createClass(RheIcon, [{
    key: "_getClassNames",
    value: function _getClassNames() {
      return (0, _stylingUtils.getClassNames)(this.props.className, {
        "rhe-icon--arrow-up": this.props.icon === "arrow up",
        "rhe-icon--blog": this.props.icon === "blog",
        "rhe-icon--discussion": this.props.icon === "discussion",
        "rhe-icon--folder": this.props.icon === "folder",
        "rhe-icon--link": this.props.icon === "link",
        "rhe-icon--suite": this.props.icon === "suite",
        "rhe-icon--user": this.props.icon === "user"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          onClick = _this$props.onClick,
          backgroundColor = _this$props.backgroundColor,
          foregroundColor = _this$props.foregroundColor,
          secondaryColor = _this$props.secondaryColor,
          altText = _this$props.altText;
      return _react.default.createElement(_Icon.default, _extends({}, this.props, {
        id: icon.replace(/\s+/g, '-') + '_' + new Date().getUTCMilliseconds(),
        className: this._getClassNames(),
        onClick: onClick,
        backgroundColor: backgroundColor,
        foregroundColor: foregroundColor,
        secondaryColor: secondaryColor,
        altText: altText,
        svg: (0, _getIcon.default)(icon)
      }));
    }
  }]);

  return RheIcon;
}(_react.default.Component);

exports.default = RheIcon;
RheIcon.defaultProps = {
  onClick: function onClick() {},
  shape: 'circle'
};
RheIcon.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  icon: _propTypes.default.string.isRequired,
  shape: _propTypes.default.oneOf(['circle', 'square'])
};